module.exports = __webpack_public_path__ + "img/pr-5.3c516065.png";